<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="$router.push('add')">新增</el-button>
    </template>

    <template #search-form>
      <el-form-item label="地区名称">
        <el-input placeholder="地区名称" v-model="searchForm.area" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">搜索</el-button>
        <el-button @click="$refs.list.reset()">重置</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">

      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="index" label="序号" width="50"/>

        <el-table-column prop="area" label="使用地区" fixed />
        <el-table-column prop="areaBack" label="使用地区（后台）" fixed />
        <el-table-column label="对应前台语言版本" prop="languageVersionFront" />
        <el-table-column label="对应后台语言版本" prop="languageVersionBack" />
        <el-table-column label="操作" width="90">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="$router.push('edit?code=' + row.code)">编辑</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">删除</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "LangList",
  components: {AnkhList, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
    }
  },
  methods: {
    async handleDelete(row) {
      try {
        await requestByTip(this.$api.areaLanguageSet.delete, {code: row.code});
        this.$message.success("操作成功")
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: '未选择记录'
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.areaLanguageSet.batchDelete,
            codes,
            {isJson: true},
            {message: "您现在正在进行批量删除操作, 是否继续?"}
        );
        this.$message.success("操作成功");
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params) {
      try {
        let res = await request(this.$api.areaLanguageSet.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        if (this.$refs?.list) {
          this.$refs.list.setTotal(res.pager?.itemCount);
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

</style>
